function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator.return && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, catch: function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/* eslint-disable react-hooks/exhaustive-deps */
import PropTypes from 'prop-types';
import React, { useCallback, useContext, useEffect, useReducer } from 'react';
import Translator from "../common/translation";
import { useParams } from "./parameters";
import { _Modal as Modal } from "../core/common";
import { WeverCoreContext } from "../../services/core";
import Api from "../../services/api";
import CollectorService from "../../services/collector";
import WorkFlowService from "../../services/workflow";
import { _Api, _Security, _translate, _Logger as Logger } from "../../services/core";
import useDiagnosticAction from "../actions";
import useAnalytics from "../../services/analytics";
import SequenceJourneyChecker from "./workflow/sequence-journey.checker";
export var WorkflowContext = /*#__PURE__*/React.createContext();
WorkflowContext.displayName = 'WorkflowContext';

// @todo Renommer l'ensemble des attributs du reducer.
export var UPDATE_DIAG = 'diag';
export var UPDATE_CURR_BLOC = 'currentBloc';
export var UPDATE_CURR_QUESTION = 'currentQuestion';
export var UPDATE_CURR_ORDER = 'currentOrder';
export var UPDATE_RESPONSES = 'responses';
export var LOADER_QUESTION = 'loaderQuestion';
export var UPDATE_SUB = 'updateSub';
export var END = 'end';
export var UPDATE_USER = 'user';
export var MAIN_LOADER = 'mainLoader';
export var UPDATE_HISTORIC = 'historic';
export var NEED_CONNECTION = 'need_connection';
export var IS_SAVED = 'saved';
export var LOCK_BUTTON = 'lock_btn';
export var SEND_BUTTON = 'send_button';
export var UPDATE_CAPTCHA = 'captcha';
export var IS_FINISHED = 'is_finished';
export var HAS_NOT_STARTED = 'has_not_started';
export var IS_SAVING = 'isSaving';
export var RESOURCES = 'resources';
export var ANALYZER_EVENT = 'analyzer-event';
export var QUESTION_TIMER_START = 'question_time_start';
export var START_DATE = 'start_date';
export var INIT_CAPTCHA = 'initCaptcha';
export var actionTypes = {
  UPDATE_DIAG: UPDATE_DIAG,
  UPDATE_CURR_BLOC: UPDATE_CURR_BLOC,
  UPDATE_CURR_QUESTION: UPDATE_CURR_QUESTION,
  UPDATE_RESPONSES: UPDATE_RESPONSES,
  IS_FINISHED: IS_FINISHED,
  LOADER_QUESTION: LOADER_QUESTION,
  END: END,
  UPDATE_CURR_ORDER: UPDATE_CURR_ORDER,
  MAIN_LOADER: MAIN_LOADER,
  UPDATE_HISTORIC: UPDATE_HISTORIC,
  NEED_CONNECTION: NEED_CONNECTION,
  LOCK_BUTTON: LOCK_BUTTON,
  SEND_BUTTON: SEND_BUTTON,
  UPDATE_CAPTCHA: UPDATE_CAPTCHA,
  HAS_NOT_STARTED: HAS_NOT_STARTED,
  RESOURCES: RESOURCES,
  QUESTION_TIMER_START: QUESTION_TIMER_START,
  INIT_CAPTCHA: INIT_CAPTCHA
};
var getCurrentDate = function getCurrentDate() {
  var date = new Date();
  date.setHours(0, 0, 0, 0);
  return Math.floor(date.getTime() / 1000);
};
var reducer = function reducer(state, action) {
  return _objectSpread(_objectSpread({}, state), {}, _defineProperty({}, action.type, action.value));
};
var initReducer = {
  diag: null,
  currentBloc: null,
  currentQuestion: null,
  currentOrder: null,
  responses: {},
  loaderQuestion: false,
  end: false,
  user: null,
  mainLoader: false,
  need_connection: false,
  captcha: false,
  saved: false,
  isSaving: false,
  send_button: false,
  initCaptcha: null,
  resources: {},
  start_date: new Date(),
  question_time_start: new Date().getTime(),
  analyzer: {
    ip: null,
    diag: null,
    date: null,
    events: []
  },
  // @todo  le but est de remplacement le current question par ceci.
  historic: {
    current: null /*{index: <integer>, order: <string>, element: <object> }*/,
    list: [
      /* {order, question}, {order, question} */
    ]
  }
};
var GetURLParameter = function GetURLParameter(sParam) {
  var sPageURL = window.location.search.substring(1);
  var sURLVariables = sPageURL.split('&');
  for (var i = 0; i < sURLVariables.length; i++) {
    var sParameterName = sURLVariables[i].split('=');
    if (sParameterName[0] === sParam) {
      return sParameterName[1];
    }
  }
};
var GetAllURLParameter = function GetAllURLParameter() {
  var sPageURL = window.location.search.substring(1);
  var sURLVariables = sPageURL.split('&');
  var result = {};
  for (var i = 0; i < sURLVariables.length; i++) {
    var sParameterName = sURLVariables[i].split('=');
    result[sParameterName[0]] = sParameterName[1];
  }
  return result;
};
var WorkFlowProvider = function WorkFlowProvider(props) {
  var diagId = props.diagId,
    children = props.children;
  // HOOKS
  var _useParams = useParams(),
    parameters = _useParams.parameters;
  // CONTEXT
  var _useContext = useContext(WeverCoreContext),
    documents = _useContext.documents,
    documentsToValid = _useContext.documentsToValid;
  var _useDiagnosticAction = useDiagnosticAction(),
    startEndAction = _useDiagnosticAction.startEndAction;
  var _useReducer = useReducer(reducer, _objectSpread(_objectSpread({}, initReducer), {}, {
      diagId: diagId,
      sub: initReducer // sub diagnostic, if filled it will be read before reading another question of the main diag.
    })),
    _useReducer2 = _slicedToArray(_useReducer, 2),
    collector = _useReducer2[0],
    dispatcher = _useReducer2[1];
  var analytics = useAnalytics(collector);
  var fetchIP = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            // const response = await fetch('https://jsonip.com');
            // const data = await response.json();

            dispatcher({
              type: START_DATE,
              value: new Date()
            });
            analytics.post.init(diagId);
          case 2:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function fetchIP() {
      return _ref.apply(this, arguments);
    };
  }();
  var initializeCollector = useCallback( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
    var response;
    return _regeneratorRuntime().wrap(function _callee2$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          _context2.next = 2;
          return WorkFlowService.processIntialization(diagId, parameters.notifier, dispatcher, actionTypes);
        case 2:
          _context2.next = 4;
          return _Api.get('/resources/configurations/maps?key=tiles');
        case 4:
          response = _context2.sent;
          dispatcher({
            type: RESOURCES,
            value: {
              map: {
                tiles: response.data
              }
            }
          });
        case 6:
        case "end":
          return _context2.stop();
      }
    }, _callee2);
  })), [diagId, parameters.notifier]);

  /**
   * Click on next or prev button.
   *
   * @param {number|string} index
   */
  var changeQuestion = /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3(index) {
      var question, _question, questionAlias, foundIndex, isFound, indexKeys, isValid;
      return _regeneratorRuntime().wrap(function _callee3$(_context3) {
        while (1) switch (_context3.prev = _context3.next) {
          case 0:
            if (!(index === -1 && collector.end)) {
              _context3.next = 6;
              break;
            }
            question = collector.currentQuestion;
            analytics.post.question('start', question);
            analytics.post.question('rollback', {
              id: 0,
              alias: 'q-end'
            });
            dispatcher({
              type: END,
              value: false
            });
            return _context3.abrupt("return");
          case 6:
            if (collector.currentQuestion) {
              _context3.next = 9;
              break;
            }
            parameters.notifier.error( /*#__PURE__*/React.createElement(Translator, {
              id: "next_question"
            }), /*#__PURE__*/React.createElement(Translator, {
              id: "no_question"
            }));
            return _context3.abrupt("return");
          case 9:
            if (!(index === 1 && collector.currentQuestion.required)) {
              _context3.next = 30;
              break;
            }
            _question = CollectorService.getCurrentOrderResponses(collector.currentOrder, collector.responses);
            if (!(!_question || !_question.responses || Object.keys(_question.responses).length === 0)) {
              _context3.next = 14;
              break;
            }
            parameters.notifier.warning( /*#__PURE__*/React.createElement(Translator, {
              id: "next_question"
            }), /*#__PURE__*/React.createElement(Translator, {
              id: "question_is_required"
            }));
            return _context3.abrupt("return");
          case 14:
            if (!(collector.currentQuestion.type.name === 'sequence-journey')) {
              _context3.next = 30;
              break;
            }
            questionAlias = collector.currentQuestion.alias;
            foundIndex = {};
            Object.keys(_question.responses).forEach(function (key) {
              var arrayKey = key.split('_j');
              var index = parseInt(arrayKey[1]);
              if (!foundIndex[index]) {
                if (key.search("".concat(questionAlias, "_mode")) !== -1 && _question.responses[key]) {
                  foundIndex[index] = true;
                } else {
                  foundIndex[index] = false;
                }
              }
            });
            isFound = true;
            indexKeys = Object.keys(foundIndex);
            indexKeys.forEach(function (index) {
              if (indexKeys.length - 1 !== parseInt(index) && !foundIndex[index]) {
                isFound = false;
              }
            });
            if (isFound) {
              _context3.next = 24;
              break;
            }
            parameters.notifier.warning( /*#__PURE__*/React.createElement(Translator, {
              id: "next_question"
            }), /*#__PURE__*/React.createElement(Translator, {
              id: "question_need_all_mode"
            }));
            return _context3.abrupt("return");
          case 24:
            _context3.next = 26;
            return SequenceJourneyChecker.isJourneyValid(_question.responses, collector.currentQuestion);
          case 26:
            isValid = _context3.sent;
            if (isValid) {
              _context3.next = 30;
              break;
            }
            parameters.notifier.warning( /*#__PURE__*/React.createElement(Translator, {
              id: "next_question"
            }), /*#__PURE__*/React.createElement(Translator, {
              id: "question_all_values_are_required"
            }));
            return _context3.abrupt("return");
          case 30:
            analytics.post.question(-1 === index ? 'rollback' : 'normal');
            WorkFlowService.processQuestionChange(index, collector, dispatcher, actionTypes, parameters.notifier, analytics);
          case 32:
          case "end":
            return _context3.stop();
        }
      }, _callee3);
    }));
    return function changeQuestion(_x) {
      return _ref3.apply(this, arguments);
    };
  }();

  /**
   * Sauvegarde les réponses du collecteur
   */
  var saveAll = /*#__PURE__*/function () {
    var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4() {
      var lunchEndAction,
        ids,
        _documentsToValid$map,
        responseToSend,
        errorData,
        _args4 = arguments;
      return _regeneratorRuntime().wrap(function _callee4$(_context4) {
        while (1) switch (_context4.prev = _context4.next) {
          case 0:
            lunchEndAction = _args4.length > 0 && _args4[0] !== undefined ? _args4[0] : true;
            if (collector.captcha) {
              _context4.next = 4;
              break;
            }
            parameters.notifier.error(_translate('save'), _translate('collectorapp_catpcha_invalid'));
            return _context4.abrupt("return");
          case 4:
            if (!(!parameters.email && !collector.user && !_Security.token)) {
              _context4.next = 7;
              break;
            }
            parameters.notifier.error(_translate('save'), _translate('collectorapp_invalid_user'));
            return _context4.abrupt("return");
          case 7:
            parameters.notifier.info(_translate('save'), _translate('saving'));
            dispatcher({
              type: IS_SAVING,
              value: true
            });
            ids = Array.isArray(documents) ? documents.map(function (document) {
              return document.id;
            }) : [];
            if (diagId === 1295) {
              ids = (_documentsToValid$map = documentsToValid === null || documentsToValid === void 0 ? void 0 : documentsToValid.map(function (doc) {
                return doc.id;
              })) !== null && _documentsToValid$map !== void 0 ? _documentsToValid$map : [];
            }
            _context4.prev = 11;
            Logger.info('Save -> ', '', {
              mail: parameters.email,
              user: collector.user,
              communityId: parameters.communityIdManager
            });
            responseToSend = CollectorService.deleteUnecessaryKeys(collector.responses);
            analytics.post.end();
            _context4.next = 17;
            return Api.post('/responses/collector', {
              responses: responseToSend,
              diagId: collector.diag.id,
              userEmail: parameters.email || collector.user,
              locale: GetURLParameter('locale'),
              responseUrl: GetAllURLParameter(),
              communityId: parameters.communityIdManager,
              validations: ids,
              catpcha: collector.captcha
            });
          case 17:
            parameters.notifier.info(_translate('collectorapp_save'), _translate('collectorapp_saved'));
            if (lunchEndAction) {
              startEndAction(collector.diag);
            }
            dispatcher({
              type: IS_SAVED,
              value: true
            });
            _context4.next = 34;
            break;
          case 22:
            _context4.prev = 22;
            _context4.t0 = _context4["catch"](11);
            errorData = _context4.t0.response ? _context4.t0.response.data : null;
            if (!(errorData && errorData.type === 'ERR_CONNECT')) {
              _context4.next = 32;
              break;
            }
            parameters.notifier.error( /*#__PURE__*/React.createElement(Translator, {
              id: "collectorapp_save"
            }), /*#__PURE__*/React.createElement(Translator, {
              id: "collectorapp_need_connection"
            }));
            dispatcher({
              type: IS_SAVED,
              value: false
            });
            dispatcher({
              type: IS_SAVING,
              value: false
            });
            dispatcher({
              type: NEED_CONNECTION,
              value: true
            });
            dispatcher({
              type: UPDATE_CAPTCHA,
              value: null
            });
            return _context4.abrupt("return");
          case 32:
            Logger.error('Save collector', 'error', {
              e: _context4.t0
            });
            parameters.notifier.error(_translate('collectorapp_save'), _translate('collectorapp_error_save'));
          case 34:
            dispatcher({
              type: IS_SAVING,
              value: false
            });
            dispatcher({
              type: UPDATE_CAPTCHA,
              value: null
            });
            dispatcher({
              type: ANALYZER_EVENT,
              value: {
                type: 'end',
                date: getCurrentDate()
              }
            });
          case 37:
          case "end":
            return _context4.stop();
        }
      }, _callee4, null, [[11, 22]]);
    }));
    return function saveAll() {
      return _ref4.apply(this, arguments);
    };
  }();
  var _getResponseLoop = function getResponseLoop() {
    return WorkFlowService.getResponseLoopFromHistoric(collector.historic, collector.currentQuestion);
  };
  useEffect(function () {
    fetchIP();
  }, []);
  return /*#__PURE__*/React.createElement(WorkflowContext.Provider, {
    value: {
      collector: collector,
      dispatcher: dispatcher,
      analytics: analytics,
      actions: {
        next: function next() {
          return changeQuestion(1);
        },
        prev: function prev() {
          return changeQuestion(-1);
        },
        save: function save() {
          var lunchEndAction = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
          return saveAll(lunchEndAction);
        },
        init: function init() {
          return initializeCollector();
        },
        historic: {
          getResponseLoop: function getResponseLoop() {
            return _getResponseLoop();
          }
        }
      }
    }
  }, children, /*#__PURE__*/React.createElement(Modal, null));
};
WorkFlowProvider.propTypes = {
  children: PropTypes.element.isRequired,
  diagId: PropTypes.number.isRequired
};
export default WorkFlowProvider;
export var useWorkFlow = function useWorkFlow() {
  return useContext(WorkflowContext);
};